import { Button } from "@blueprintjs/core";

import completed from "@/../../hypetrain/static/img/program/completed.svg";
import { EmbedSvg } from "@/components/helpers/ui/EmbedSvg";
import { Box, Flex } from "@/components/layout/flexbox";
import { buildComponentMetadata } from "@/components/pages_logged_in/program/components/componentMetadata";
import { ComponentTabProps } from "@/types/programs";

export function Completed({
  onClose,
  onAddMore,
  programComponent,
  isEdit,
}: ComponentTabProps) {
  const metaData = buildComponentMetadata({ component: programComponent });
  return (
    <Flex
      maxWidth={600}
      margin={"0 auto"}
      height={"100%"}
      justifyContent={"center"}
      flexDirection={"column"}
    >
      <Box textAlign={"center"} mt={4}>
        <EmbedSvg src={completed} width={80} className="inline" />
      </Box>
      <Box fontSize={30} textAlign={"center"} fontWeight={600} my={2}>
        You’re All Set
      </Box>
      <Box fontSize={18} textAlign={"center"}>
        Great job! Your {metaData?.componentTypeName} is configured and ready to
        go.
      </Box>

      <Box mt={4} textAlign={"center"}>
        <Button
          style={{ minWidth: 280 }}
          large={true}
          intent="primary"
          disabled={false}
          onClick={() => {
            onClose();
          }}
        >
          Close
        </Button>
      </Box>

      {!isEdit && (
        <Box mt={3} textAlign={"center"}>
          <Button
            style={{ minWidth: 280 }}
            large={true}
            intent="none"
            disabled={false}
            onClick={onAddMore}
          >
            Add Another Component
          </Button>
        </Box>
      )}
    </Flex>
  );
}
